import { render, staticRenderFns } from "./AdminCalendar.vue?vue&type=template&id=66b4f7eb&scoped=true"
import script from "./AdminCalendar.vue?vue&type=script&lang=js"
export * from "./AdminCalendar.vue?vue&type=script&lang=js"
import style0 from "./AdminCalendar.vue?vue&type=style&index=0&id=66b4f7eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b4f7eb",
  null
  
)

export default component.exports